import React from 'react';
import { FiPhoneOff, FiPlus, FiVolume2 } from 'react-icons/fi';
import { BsClipboardCheck, BsLink45Deg } from 'react-icons/bs';
import { HiOutlinePause } from 'react-icons/hi2';
import { LuPanelRightOpen } from 'react-icons/lu';
import { confParticipants } from '../ctiData';
import { controlIcon, formatSeconds } from '../ctiHelpers';

function ConferenceScreen({ confSeconds, onLeave, onEndAll }) {
  return (
    <div className="screen active">
      <div className="conf-layout">
        <div className="conf-main">
          <div className="conf-header">
            <div className="conf-link"><BsLink45Deg /></div>
            <div className="flex-1">
              <div className="conf-title-txt">Conference Bridge Active</div>
              <div className="conf-subtitle">+91 22 4000 9900 - PIN 8812# - 3 Participants</div>
            </div>
            <div className="conf-main-timer">{formatSeconds(confSeconds)}</div>
          </div>
          <div className="conf-participants">
            {confParticipants.map((person) => (
              <div className={`conf-part-item ${person.hold ? 'on-hold' : ''}`} key={person.name}>
                <div className="part-avatar" style={person.tone}>{person.initials}</div>
                <div className="flex-1">
                  <div className="part-name">{person.name} <span className="part-meta">{person.meta}</span></div>
                  <div className="part-role">{person.role}</div>
                </div>
                <div className="part-status-wrap">
                  <div className={`part-status ${person.statusClass}`}>
                    {person.speaking ? <><div className="speak-bars"><div className="speak-bar" /><div className="speak-bar" /><div className="speak-bar" /><div className="speak-bar" /><div className="speak-bar" /></div>{person.status}</> : person.status}
                  </div>
                  <div className="part-dur">{person.duration}</div>
                </div>
                <div className="part-controls">
                  {person.controls.map((key, idx) => (
                    <button key={`${person.name}-${key}`} type="button" className={`part-ctrl-btn ${idx === 2 ? 'red' : ''} ${person.hold && idx === 0 ? 'green-toggle' : ''}`}>{controlIcon(key)}</button>
                  ))}
                </div>
              </div>
            ))}
            <div className="add-participant-card">
              <div className="add-participant-icon"><FiPlus /></div>
              <div><div className="add-participant-title">Add Participant</div><div className="add-participant-sub">Dial or search directory</div></div>
            </div>
          </div>
          <div className="conf-global-ctrl">
            <button type="button" className="conf-ctrl-btn"><span className="ci"><HiOutlinePause /></span>Hold All</button>
            <button type="button" className="conf-ctrl-btn"><span className="ci"><FiVolume2 /></span>Mute All</button>
            <button type="button" className="conf-ctrl-btn"><span className="ci"><BsClipboardCheck /></span>Record</button>
            <button type="button" className="conf-ctrl-btn add"><span className="ci"><FiPlus /></span>Add</button>
            <button type="button" className="conf-ctrl-btn" onClick={onLeave}><span className="ci"><LuPanelRightOpen /></span>Leave</button>
            <button type="button" className="conf-ctrl-btn end" onClick={onEndAll}><span className="ci"><FiPhoneOff /></span>End All</button>
          </div>
        </div>

        <div className="conf-sidebar">
          <div className="crm-card">
            <div className="crm-section-title">Bridge Details</div>
            <div className="crm-field"><span className="crm-key">Bridge Number</span><span className="crm-val blue">+91 22 4000 9900</span></div>
            <div className="crm-field"><span className="crm-key">PIN</span><span className="crm-val">8812#</span></div>
            <div className="crm-field"><span className="crm-key">Started</span><span className="crm-val">11:42 AM</span></div>
            <div className="crm-field"><span className="crm-key">Duration</span><span className="crm-val purple">00:12:08</span></div>
            <div className="crm-field"><span className="crm-key">Recording</span><span className="crm-val red">REC</span></div>
            <div className="crm-field">
              <span className="crm-key">Quality</span>
              <div className="quality-bars"><div className="q-bar filled small" /><div className="q-bar filled mid" /><div className="q-bar filled tall" /><div className="q-bar filled x-tall" /><div className="q-bar empty xx-tall" /></div>
            </div>
          </div>
          <div className="crm-card">
            <div className="crm-section-title">Conference Notes</div>
            <textarea className="conf-notes" defaultValue="Customer agreed to documentation review. RM Rohit to prepare revised EMI comparison sheet and send before EOD." />
          </div>
          <div className="crm-card">
            <div className="crm-section-title">AI Live Summary</div>
            <div className="ai-hint summary-gap"><div className="ai-tag">Key Points So Far</div><div className="ai-text">Customer asked about <strong>20yr tenure</strong>. RM confirmed pre-approval. Rate <strong>8.45%</strong> accepted verbally. Documentation pending.</div></div>
            <div className="ai-hint green-ai"><div className="ai-tag green-text">Suggested Action</div><div className="ai-text">Resume RM Rohit from hold to confirm document pickup schedule directly with Priya.</div></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ConferenceScreen);
